/**
 * Created by AlexanderC on 5/27/15.
 */

'use strict';

/**
 * Simple object storage implementation
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let ObjectStorage = exports.ObjectStorage = function () {
  /**
   * @param {Array} objects
   */
  function ObjectStorage() {
    for (var _len = arguments.length, objects = Array(_len), _key = 0; _key < _len; _key++) {
      objects[_key] = arguments[_key];
    }

    _classCallCheck(this, ObjectStorage);

    if (objects.length === 1 && objects[0] instanceof Array) {
      objects = objects[0];
    }

    this._vector = objects;
  }

  /**
   * @param {*} object
   * @returns {ObjectStorage}
   */


  _createClass(ObjectStorage, [{
    key: 'add',
    value: function add(object) {
      this._vector.push(object);

      return this;
    }

    /**
     * @param {Function|Object} thing
     * @param {Boolean} strict
     * @returns {Object|null}
     */

  }, {
    key: 'find',
    value: function find(thing) {
      let strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      for (let objectKey in this._vector) {
        if (!this._vector.hasOwnProperty(objectKey)) {
          continue;
        }

        let object = this._vector[objectKey];

        if (strict && object === thing || !strict && object instanceof thing) {
          return object;
        }
      }

      return null;
    }

    /**
     * @returns {Array}
     */

  }, {
    key: 'iterator',
    get: function get() {
      return this._vector;
    }
  }]);

  return ObjectStorage;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Generic/ObjectStorage.js
// module id = 372
// module chunks = 0